jQuery_T4NT(document).ready(function ($) {
  const selectVariantFromChart = (dataValue) => {
    var variant = document.querySelector(
      `div.t4s-swatch__item[data-value="${dataValue}"]`
    );
    if (variant) variant.click();
  };

  // const addGuidePopup = (name, )
  if (window.location.href.includes("/products")) {
    var swatchOptions = document.querySelectorAll(".t4s-swatch__title");

    const fileUrl = window.firmnessGuideUrl;
    if (fileUrl && fileUrl.includes(".txt")) {
      var name = swatchOptions[1].textContent.toLowerCase().includes("tog")
        ? "Tog Guide"
        : "Firmness Guide";
      swatchOptions[1].innerHTML += `<a class="t4s-ch t4s-btn__size-chart" style="cursor: pointer;" id="openFirmnessGuide">${name}</a>`;
      fetch(fileUrl)
        .then((response) => response.text())
        .then((data) => {
          var d = document.createElement("div");
          d.classList.add("custom-guide-popup");
          d.innerHTML = data;
          document.body.appendChild(d);
          return data;
        })
        .then(() => {
          const openButton = document.getElementById("openFirmnessGuide");
          const popup = document.getElementById("firmnessGuidePopup");
          const overlay = document.getElementById("firmnessOverlay");

          openButton.addEventListener("click", () => {
            popup.style.display = "block";
            overlay.style.display = "block";
          });

          overlay.addEventListener("click", () => {
            popup.style.display = "none";
            overlay.style.display = "none";
          });
          document.querySelectorAll("div.popup > table tr").forEach((e) => {
            e.addEventListener("click", () => {
              var dv = e.getAttribute("data-value");
              console.log(dv);
              selectVariantFromChart(dv);
              overlay.click();
            });
          });
        });
    }

    const sizeUrl = window.sizeGuideUrl;
    if (sizeUrl && sizeUrl.includes(".txt")) {
      swatchOptions[0].innerHTML += `<a class="t4s-ch t4s-btn__size-chart" style="cursor: pointer;" id="openSizeGuide">Size Measurements Guide</a>`;
      console.log("run");
      fetch(sizeUrl)
        .then((response) => response.text())
        .then((data) => {
          var d = document.createElement("div");
          d.classList.add("custom-guide-popup");
          d.innerHTML = data;
          document.body.appendChild(d);
          return data;
        })
        .then(() => {
          const openButton = document.getElementById("openSizeGuide");
          const popup = document.getElementById("sizeGuidePopup");
          const overlay = document.getElementById("overlay");

          openButton.addEventListener("click", () => {
            popup.style.display = "block";
            overlay.style.display = "block";
          });

          overlay.addEventListener("click", () => {
            popup.style.display = "none";
            overlay.style.display = "none";
          });

          document.querySelectorAll("div.popup > table tr").forEach((e) => {
            e.addEventListener("click", () => {
              var dv = e.getAttribute("data-value");
              selectVariantFromChart(dv);
              overlay.click();
            });
          });

          // For multiple options like Bed Linen product //
          document.querySelectorAll(".buttons button").forEach((button) => {
            console.log("button");
            button.addEventListener("click", () => {
              var tableId = button.getAttribute("data-value");
              document.querySelectorAll(".popup table").forEach((table) => {
                table.classList.add("multi-tables");
              });
              document.getElementById(tableId).classList.remove("multi-tables");
              button.parentElement
                .querySelectorAll("button")
                .forEach((btn) => btn.classList.remove("selected"));
              button.classList.add("selected");
            });
          });
          // end //
        });
    }
  }

  // customer service section
  try {
    var cs = document.querySelector(
      "#shopify-section-announcement-bar > div > div.ds > div > div > div"
    ).classList;
    cs.add("deactive");
    var hover = document.querySelector(".ds");
    hover.addEventListener("mouseover", () => {
      cs.remove("deactive");
    });
    hover.addEventListener("mouseout", () => {
      cs.add("deactive");
    });
  } catch (error) {
    console.log("Error at customer service section: ");
    console.log(error);
  }

  // read more button
  try {
    document.querySelector("#readMorebtn").addEventListener("click", () => {
      document
        .querySelector("#t4s-tab-destemplate--24639631720835__main")
        .setAttribute("style", "display: block !important;");
    });
  } catch (error) {
    console.log("Error at read more button: ");
    console.log(error);
  }
});
